/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: PasswordRestrictions
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 15Aug2022 craig File created.
 \******************************************************************************/
import {Col, Row} from "react-bootstrap";
import React from "react";

export const PasswordRestrictions = () => {
    return (
        <Row>
            <Col>
                <ul>
                    <li>Passwords must be 8 - 15 characters and must contain all of the following:</li>
                    <li>Uppercase alpha characters (A - Z)</li>
                    <li>Lowercase alpha characters (a - z)</li>
                    <li>Numbers (0 - 9)</li>
                    <li>Non-alphanumeric special characters (@, !, $, #, %, etc.)</li>
                    <li>Passwords cannot contain:
                        <ul>
                            <li>User account, first or last name</li>
                            <li>Leading or trailing blanks</li>
                            <li>All or part of a previous password; for example, if "StrongPassword1" was used before, "StrongPassword2" cannot be a new password</li>
                        </ul>
                    </li>
                    <li>Additional Password rules:
                        <ul>
                            <li>User accounts will be locked out after five (5) unsuccessful login attempts; users can attempt to reset their password after 30 minutes</li>
                            <li>No password changes on consecutive days</li>
                        </ul>
                    </li>
                </ul>
            </Col>
        </Row>
    )
}